import {
  PROJECTS_ADMIN_CRUD_MODAL,
  PROJECTS_ADMIN_SET_USER_LIST,
  PROJECTS_ADMIN_SET_PROJECTS_LIST,
  PROJECTS_ADMIN_SELECTED_USER,
  PROJECTS_ADMIN_IS_LOADING, PROJECTS_ADMIN_LOADED_OTHER_U_PROJECT, PROJECTS_ADMIN_MULTIBED_WARNING,
} from "../lib/types";

const initialState = {
  showProjectsAdminCrudModal: false,
  projects: [],
  users: [],
  selectedUser:{},
  isLoading:false,
  isProjectFromAnotherUsr:false,
  showMultibedSaveWarning: false,
};

export let ProjecstAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROJECTS_ADMIN_CRUD_MODAL:
      return {
        ...state,
        showProjectsAdminModal: action.payload,
      };

    case PROJECTS_ADMIN_MULTIBED_WARNING:
      return {
        ...state,
        showMultibedSaveWarning: action.payload,
      };

    case PROJECTS_ADMIN_SET_USER_LIST:
      return {
        ...state,
        users: action.payload,
      };
    case PROJECTS_ADMIN_SET_PROJECTS_LIST:
      return {
        ...state,
        projects: action.payload.projects,
        iTokens: action.payload.iTokens
      };
    case PROJECTS_ADMIN_SELECTED_USER:
      return{
        ...state,
        selectedUser:action.payload
      };
    case PROJECTS_ADMIN_IS_LOADING:
      return{
        ...state,
        isLoading:action.payload
      };
    case PROJECTS_ADMIN_LOADED_OTHER_U_PROJECT:
      return{
        ...state,
        isProjectFromAnotherUsr: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/projects-admin-reducer.js